import { IntterraImageProduct } from "@nova/constants"
import { fetchApiGateway } from "@nova/fetch-api-gateway"

interface IntterraTransferParams {
    workspaceId: string
    fireId: string
    flightIds: string[]
    imageType: IntterraImageProduct
    perimeterArea?: string
}

export function useIntterraTransfer() {
    const handleTransfer = async ({
        workspaceId,
        fireId,
        flightIds,
        imageType,
        perimeterArea,
    }: IntterraTransferParams) => {
        const response = await fetchApiGateway(
            "post /org/:orgId/project/:projectId/integrations/intterra/export",
            {
                params: { orgId: workspaceId, projectId: fireId },
                body: { flightIds, imageType, perimeterArea },
                rawResponse: true,
            }
        )

        if (!response.ok) throw new Error("Failed to connect with Intterra")

        return await response.json()
    }

    return {
        transferIntterraData: handleTransfer,
    }
}
